export const DbStorageErrorsModal = {
  QuotaExceededError: {
    title: 'Reaxys recognized low disk space.',
    text: 'Please ensure that you have at least 2Gb of free disk space, then try again.',
    confirmText: 'Close',
    type: 'error',
    backdrop: 'static',
  },
};
